(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ganvu-faq"] && !Shopify.designMode) return;
  try {
    
// Theme editor: selecting a question block opens it, so the answer being edited is visible.
document.addEventListener('shopify:block:select', (event) => { if (event.target.matches('.gv-faq details')) event.target.open = true; });
document.addEventListener('shopify:block:deselect', (event) => { if (event.target.matches('.gv-faq details')) event.target.open = false; });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ganvu-home"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  document.querySelectorAll('.gh-mobile-menu[open]').forEach((menu) => {
    if (!menu.contains(event.target) || event.target.closest('a')) menu.removeAttribute('open');
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') document.querySelectorAll('.gh-mobile-menu[open]').forEach((menu) => { menu.removeAttribute('open'); menu.querySelector('summary').focus(); });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ganvu-safe"] && !Shopify.designMode) return;
  try {
    
(()=>{
function init(root){
 if(root.dataset.initialized)return;
 root.dataset.initialized='true';
 const controller=new AbortController();
 const listen=(target,event,handler,options={})=>target?.addEventListener(event,handler,{...options,signal:controller.signal});
 const copy=JSON.parse(root.querySelector('[data-ganvu-copy]').textContent);
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 const tabs=[...root.querySelectorAll('[data-gallery-choice]')];
 function showImage(tab){tabs.forEach(t=>{const selected=t===tab;t.setAttribute('aria-selected',String(selected));t.tabIndex=selected?0:-1});root.querySelectorAll('[data-gallery-view]').forEach(view=>view.hidden=view.dataset.galleryView!==tab.dataset.galleryChoice)}
 tabs.forEach((tab,index)=>{listen(tab,'click',()=>showImage(tab));listen(tab,'keydown',event=>{if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;event.preventDefault();const next=event.key==='Home'?0:event.key==='End'?tabs.length-1:(index+(event.key==='ArrowLeft'?1:-1)+tabs.length)%tabs.length;showImage(tabs[next]);tabs[next].focus()})});
 function moveImage(direction){if(tabs.length<2)return;const current=tabs.findIndex(tab=>tab.getAttribute('aria-selected')==='true');showImage(tabs[(current+direction+tabs.length)%tabs.length])}
 root.querySelectorAll('[data-gallery-move]').forEach(button=>listen(button,'click',()=>moveImage(Number(button.dataset.galleryMove))));
 const gallery=root.querySelector('.gs-gallery-stage');let pointerStart;
 listen(gallery,'pointerdown',event=>{if(event.pointerType==='touch')pointerStart={x:event.clientX,y:event.clientY}});
 listen(gallery,'pointerup',event=>{if(!pointerStart)return;const dx=event.clientX-pointerStart.x,dy=event.clientY-pointerStart.y;pointerStart=null;if(Math.abs(dx)>55&&Math.abs(dx)>Math.abs(dy)*1.5)moveImage(dx>0?1:-1)});
 listen(gallery,'pointercancel',()=>pointerStart=null);
 root.querySelectorAll('a[href^="#"]').forEach(link=>listen(link,'click',event=>{const destination=root.querySelector(link.getAttribute('href'));if(!destination)return;event.preventDefault();const menu=root.querySelector('.gr-menu');if(menu)menu.open=false;destination.scrollIntoView({block:'start',behavior:reduced.matches?'instant':'smooth'})}));
 const input=root.querySelector('.ganvu-quantity'),minus=root.querySelector('[data-quantity="minus"]'),plus=root.querySelector('[data-quantity="plus"]');
 const formatter=new Intl.NumberFormat(root.dataset.locale||'he-IL',{style:'currency',currency:root.dataset.currency||'ILS'});
 const packs=[...root.querySelectorAll('[data-pack-choice]')];
 function renderQuantity(){if(!input)return;const min=Number(input.min)||1,step=Number(input.step)||1,max=input.max?Number(input.max):Number.MAX_SAFE_INTEGER;let count=Number(input.value);if(!Number.isFinite(count))count=min;count=Math.max(min,Math.min(max,min+Math.round((count-min)/step)*step));input.value=String(count);minus.disabled=count<=min;plus.disabled=count+step>max;root.querySelector('.ps-total output').value=formatter.format(count*Number(root.dataset.unitPrice)/100);packs.forEach(pack=>pack.checked=Number(pack.value)===count)}
 packs.forEach(pack=>listen(pack,'change',()=>{if(!input||!pack.checked)return;input.value=pack.value;renderQuantity();input.dispatchEvent(new Event('change',{bubbles:true}))}));
 if(input){listen(minus,'click',()=>{input.stepDown();renderQuantity();input.dispatchEvent(new Event('change',{bubbles:true}))});listen(plus,'click',()=>{input.stepUp();renderQuantity();input.dispatchEvent(new Event('change',{bubbles:true}))});listen(input,'input',()=>{if(input.value!==''&&input.validity.valid)renderQuantity()});listen(input,'change',renderQuantity);listen(window,'pageshow',renderQuantity);renderQuantity()}
 const demo=root.querySelector('.gs-demo'),play=root.querySelector('.gs-play');let timer=0,count=0,seen=false;
 function setStep(state){if(!demo)return;demo.dataset.state=state;root.querySelectorAll('[data-step]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.step===state)));const image=demo.querySelector('.gs-demo-photo');if(image)image.setAttribute('aria-label',state==='pull'?copy.pull_image:copy.insert_image)}
 function stop(){clearTimeout(timer);timer=0;if(play){play.setAttribute('aria-pressed','false');play.querySelector('span').textContent=copy.play}}
 function start(){stop();if(reduced.matches){setStep(demo.dataset.state==='pull'?'insert':'pull');return}count=0;play.setAttribute('aria-pressed','true');play.querySelector('span').textContent=copy.pause;setStep('pull');const next=()=>{if(!root.isConnected||reduced.matches||++count>=4){stop();return}setStep(count%2?'insert':'pull');timer=setTimeout(next,1500)};timer=setTimeout(next,1500)}
 listen(play,'click',()=>timer?stop():start());root.querySelectorAll('[data-step]').forEach(button=>listen(button,'click',()=>{stop();setStep(button.dataset.step)}));
 const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(!entry.isIntersecting){stop();return}if(!seen&&entry.intersectionRatio>.6&&play&&!reduced.matches){seen=true;start()}}),{threshold:[0,.6]});if(demo)observer.observe(demo);
 const stage=root.querySelector('.gs-gallery-stage'),art=root.querySelector('.gs-product-art');let raf=0;
 const draw=()=>{raf=0;if(!art||!stage)return;const r=stage.getBoundingClientRect();const shift=reduced.matches?0:Math.max(-12,Math.min(12,-r.top*.045));art.style.setProperty('--gs-rise',shift+'px')};
 const schedule=()=>{if(!raf)raf=requestAnimationFrame(draw)};
 listen(window,'scroll',schedule,{passive:true});listen(reduced,'change',()=>{stop();schedule()});schedule();
 root.ganvuCleanup=()=>{stop();observer.disconnect();cancelAnimationFrame(raf);controller.abort();root.querySelectorAll('video').forEach(video=>video.pause())};
}
function initialize(container){if(container.matches?.('[data-ganvu-safe]'))init(container);container.querySelectorAll('[data-ganvu-safe]').forEach(init)}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialize(document),{once:true});else initialize(document);
document.addEventListener('shopify:section:load',event=>initialize(event.target));
document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-ganvu-safe]').forEach(root=>root.ganvuCleanup?.()));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
